<template>
  <div class="error-container">
    <div class="error-code">404</div>
    <h1 class="error-title">哎呀！页面未找到</h1>
    <p class="error-message">
      抱歉，您访问的页面不存在。<a :href="indexUrl" class="error-btn-primary">点击返回首页</a>
    </p>
    <div class="error-animation">
      <img :src="src" style="width: 200px">

    </div>
  </div>
</template>
<script>
import cry from '../image/cry.png'
export default {
  name:'LENotFound',
  props:{
    indexUrl:{
      default:'/'
    }
  },
  data(){
    return{
      src:cry,
    }
  }
}
</script>

<style scoped>
.error-container {
  margin: auto;
  max-width: 800px;
  width: 100%;
  text-align: center;
  padding: 40px;
  /*background: rgba(255, 255, 255, 0.9);*/
  border-radius: 20px;
  /*box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);*/
}

.error-code {
  font-size: 100px;
  font-weight: 500;
  color: #aeb1b4;
  margin-bottom: 20px;
  line-height: 1;
  /*text-shadow: 4px 4px 0px rgba(0, 0, 0, 0.1);*/
  /*animation: pulse 2s infinite;*/
}

.error-title {
  font-size: 32px;
  margin-bottom: 20px;
  color: #333;
}

.error-message {
  font-size: 18px;
  margin-bottom: 30px;
  color: #666;
  line-height: 1.6;
}

.error-btn-primary {
  font-style: italic;
  color: #419fff;
  font-size: 16px;
}

.error-btn-primary:hover {
  color: #526ed3;
  transform: translateY(-2px);
}

.error-animation {
  margin: 30px auto;
  max-width: 300px;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@media (max-width: 600px) {
  .error-code {
    font-size: 80px;
  }

  .error-title {
    font-size: 24px;
  }
}
</style>
